import { Header } from '../../../components/feature/Header';
import { Footer } from '../../../components/feature/Footer';
import { MixedUsePropertiesHero } from './components/MixedUsePropertiesHero';
import { WhatAreMixedUseProperties } from './components/WhatAreMixedUseProperties';
import { WhyWeSpecialize } from './components/WhyWeSpecialize';
import { PropertyTypesWeBuy } from './components/PropertyTypesWeBuy';
import { OurPurchaseProcess } from './components/OurPurchaseProcess';
import { SellerBenefits } from './components/SellerBenefits';
import { CommonChallenges } from './components/CommonChallenges';
import { MarketInsights } from './components/MarketInsights';
import { CaseStudies } from './components/CaseStudies';
import { GetOfferSection } from './components/GetOfferSection';
import { MixedUsePropertiesFAQ } from './components/MixedUsePropertiesFAQ';
import { FinalCTA } from './components/FinalCTA';

export default function MixedUsePropertiesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <MixedUsePropertiesHero />
      <WhatAreMixedUseProperties />
      <WhyWeSpecialize />
      <PropertyTypesWeBuy />
      <OurPurchaseProcess />
      <SellerBenefits />
      <CommonChallenges />
      <MarketInsights />
      <CaseStudies />
      <GetOfferSection />
      <MixedUsePropertiesFAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}